import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import LoginCSS from "./Login.module.css";
import { loginApi } from "../../apis/AuthAPICalls";


export default function Login() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	// 이메일 기억하기(localStorage)
	const savedEmail = localStorage.getItem("rememberEmail") || "";
	const [email, setEmail] = useState(savedEmail);
	const [password, setPassword] = useState("");
	const [rememberEmail, setRememberEmail] = useState(!!savedEmail);
	const [rememberMe, setRememberMe] = useState(localStorage.getItem("rememberMe") === "true");
	const [errors, setErrors] = useState({});

	// 유효성 검사
	const validateField = (field) => {
		const newErrors = { ...errors };
		if (field === "email") {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			newErrors.email = emailRegex.test(email) ? "" : "올바른 이메일 주소를 입력해주세요.";
		}
		if (field === "password") {
			newErrors.password = password ? "" : "비밀번호를 입력해주세요.";
		}
		setErrors(newErrors);
	};

	// 제출
	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors({}); // 초기화
		
		// 이메일 유효성 체크
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			setErrors({ email: "올바른 이메일 주소를 입력해주세요." });
			return;
			}
		
			// 비밀번호 체크
			if (!password) {
			setErrors({ password: "비밀번호를 입력해주세요." });
			return;
			}
		
			// 오류 없으면 로그인 시도
			try {
			const result = await dispatch(loginApi({ email, password }));
		
			// 이메일 기억하기
			if (rememberEmail) localStorage.setItem("rememberEmail", email);
			else localStorage.removeItem("rememberEmail");
		
			// 자동 로그인 체크
			if (rememberMe) localStorage.setItem("rememberMe", "true");
			else localStorage.removeItem("rememberMe");
		
			navigate("/"); // 로그인 성공
			} catch (err) {
			console.error("로그인 실패:", err);
			setErrors({ global: "로그인 정보가 올바르지 않습니다." });
			}
		};

	return (
		<div className={LoginCSS.background}>
			<div className={LoginCSS.container}>
				<form className={LoginCSS.formCard} onSubmit={handleSubmit}>
					<h2 className={LoginCSS.title}>My Palette AI 로그인</h2>

					{/* 이메일 */}
					<div className={LoginCSS.row}>
						<div className={LoginCSS.rowInner}>
							<label>이메일</label>
							<input
								type="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								onBlur={() => validateField("email")}
								required
							/>
						</div>
						{errors.email && <p className={LoginCSS.error}>{errors.email}</p>}
					</div>

					{/* 비밀번호 */}
					<div className={LoginCSS.row}>
						<div className={LoginCSS.rowInner}>
							<label>비밀번호</label>
							<input
								type="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								onBlur={() => validateField("password")}
								required
							/>
						</div>
						{errors.password && <p className={LoginCSS.error}>{errors.password}</p>}
					</div>

					{/* 체크박스 그룹 */}
					<div className={LoginCSS.checkboxGroup}>
						<label className={LoginCSS.checkboxItem}>
							<input
								type="checkbox"
								checked={rememberEmail}
								onChange={(e) => setRememberEmail(e.target.checked)}
							/>
							이메일 기억하기
						</label>

						<label className={LoginCSS.checkboxItem}>
							<input
								type="checkbox"
								checked={rememberMe}
								onChange={(e) => setRememberMe(e.target.checked)}
							/>
							자동 로그인
						</label>
					</div>

					{/* 글로벌 에러 */}
					{errors.global && <p className={LoginCSS.error}>{errors.global}</p>}

					{/* 비밀번호 찾기 / 회원가입 버튼 */}
					<div className={LoginCSS.linkRow}>
						<Link to="/auth/signup" className={LoginCSS.linkButton}>
							회원가입
						</Link>
						<Link to="/auth/reset-password-request" className={LoginCSS.linkButton}>
							비밀번호 찾기
						</Link>
					</div>

					<button className={LoginCSS.submitButton} type="submit">
						(*˙˘˙)♡ 로그인 ♡(˙˘˙*)
					</button>
				</form>
			</div>
		</div>
	);
}